import React, {useState} from 'react';
import PropTypes from 'prop-types';
import TextField from "@material-ui/core/TextField";

export default function ColumnFilterTextField(props) {
    const {
        onChange,
        ...rest
    } = props;
    const [value, setValue] = useState();

    const handleChange = event => {
        setValue(event.target.value);
    };

    const handleKeyUp = event => {
        if (event.keyCode === 13) {
            onChange && onChange(value);
        }
    };

    return (
        <TextField
            {...rest}
            fullWidth
            size="small"
            onChange={handleChange}
            onKeyUp={handleKeyUp} />
    );
};

ColumnFilterTextField.propTypes = {
    id: PropTypes.string,
    onChange: PropTypes.func.isRequired
};